<shortcut-menu [subscription]="subscription()">
  <malfunction-item [subscription]="subscription()" [messages]="activities()" />
  <availability-item [subscription]="subscription()" />
  <self-service-item [subscription]="subscription()" />
  <availability-export-item [subscription]="subscription()" />
  <send-config-item [subscription]="subscription()" />
  <to-cert-item [subscription]="subscription()" />
</shortcut-menu>
